import { render, staticRenderFns } from "./MulVideo.vue?vue&type=template&id=b5883d60"
import script from "./MulVideo.vue?vue&type=script&lang=js"
export * from "./MulVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports